export default __webpack_public_path__ + "static/media/no-report-data.83f6ba80.svg";